import axios from 'axios';

class DeliveryOptionsApiService {
  async getDeliveryOptions(storeGuid) {
    return axios.get(`deliveryoptions/${storeGuid}`).then((response) => response.data);
  }

  async saveDeliveryOptions(storeGuid, updatedId, deliveryOptions) {
    return axios.post(`deliveryoptions/${storeGuid}/${updatedId}`, deliveryOptions).then((response) => response.data);
  }

  async getDeliveryOptionById(storeGuid, id) {
    return axios.get(`deliveryoptions/${storeGuid}/option/${id}`).then((response) => response.data);
  }

  async deleteDeliveryOptionById(storeGuid, id) {
    return axios.delete(`deliveryoptions/${storeGuid}/option/${id}`).then((response) => response.data);
  }

  async getStoreStatus(storeGuid) {
    return axios.get(`deliveryoptions/${storeGuid}/status`).then((response) => response.data);
  }

  async registerStore(storeGuid) {
    return axios.post(`deliveryoptions/${storeGuid}/register`, undefined).then((response) => response.data);
  }

  async getPreviewData(request) {
    const { storeGuid } = request;
    const sanitizedRequest = { ...request };
    delete sanitizedRequest.storeGuid;
    return axios.post(`deliveryOptions/${storeGuid}/previewV3`, sanitizedRequest).then((response) => response.data);
  }

  async checkShopifyStatus(storeGuid) {
    return axios.get(`deliveryoptions/${storeGuid}/checkShopifyStatus`).then((response) => response.data);
  }

  async checkSupportsDeliveryOptions(storeGuid) {
    return axios.get(`deliveryoptions/${storeGuid}/checkSupportsDeliveryOptions`).then((response) => response.data);
  }
}

export default new DeliveryOptionsApiService();
